import moment from 'moment'

export default function({ route, redirect }) {
  if (route.path.startsWith('/manutencao')) return
  const hours = moment
    .utc()
    .add(-3, 'hours')
    .hours()
  const init = 1
  const end = 3
  if (hours >= init && hours <= end) return redirect('/manutencao')
}
